// NotificationCenter.js
// Simple notification/toast system for IDE
import React, { useState, useEffect, createContext, useContext } from 'react';

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const notify = (message, type = 'info', duration = 3500) => {
    const id = Date.now() + Math.random();
    setNotifications((prev) => [...prev, { id, message, type }]);
    setTimeout(() => {
      setNotifications((prev) => prev.filter((n) => n.id !== id));
    }, duration);
  };

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      <div style={{ position: 'fixed', top: 24, right: 24, zIndex: 2000 }}>
        {notifications.map((n) => (
          <div key={n.id} style={{
            background: n.type === 'error' ? '#e74c3c' : n.type === 'success' ? '#2ecc40' : '#232323',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: 8,
            marginBottom: 12,
            boxShadow: '0 2px 16px #0005',
            fontSize: 15,
            minWidth: 220,
            maxWidth: 340,
            wordBreak: 'break-word',
            fontWeight: 500,
          }}>
            {n.message}
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  );
};
